import { useQuery } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { useDeviceStore } from '@/stores/device';
import { useHeaderStore } from '@/stores/header';

import { api } from './_http';

type GetBannerMultiDataType = {
	type: string;
};
type Banner = {
	banner_image_url: string;
	banner_mo_url: string;
	banner_url: string;
};
type GetBannerMultiResType = {
	main_top_slide?: Banner[];
	main_middle?: Banner[];
	main_bottom?: Banner[];
	main_top_normal?: Banner[];
	rise_rate?: Banner[];
	benefit?: Banner[];
	benefit_top?: Banner[];
	company_analysis?: Banner[];
	hotranking?: Banner[];
	notice?: Banner[];
	knowhow?: Banner[];
	timing?: Banner[];
	interest?: Banner[];
	etf_top?: Banner[];
	etf_bottom?: Banner[];
};
export const useGetBannerMultiApi = (params: GetBannerMultiDataType) => {
	const deviceStore = useDeviceStore();
	const headerStore = useHeaderStore();
	const url = '/v1/front/getBannerMulti';
	return useQuery<AxiosResponse, AxiosError, GetBannerMultiResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, { ...params, device: deviceStore.getDevice, country: headerStore.getCountry }),
		select: (res) => res.data.data,
	});
};
